import React from 'react';
import { Link } from 'react-router-dom';
import { roundToDecimal } from '../../utils/mathUtils';

const MiniCartItem = ({ item, index, storagePath, isLoggedIn, onRemove }) => {
    return (
        <div className="minicart-prd row" key={item.id}>
            <div className="minicart-prd-image image-hover-scale-circle col">
                <Link to={`/product?id=${item.id}`} className="prd-img pb-0">
                    <div className="product-image" style={{ backgroundImage: `url('${storagePath}${item.image}')` }}>
                        <img src="/images/skins/fashion/products/product-01-1.jpg"
                            alt={item.name}
                            className="fade-up" />
                    </div>
                </Link>
            </div>
            <div className="minicart-prd-info col">
                <h2 className="minicart-prd-name"><a href="#">{item.name}</a></h2>
                <div className="minicart-prd-qty">
                    <span className="minicart-prd-qty-label">Quantity:</span>
                    <span className="minicart-prd-qty-value">{item.quantity}</span>
                </div>
                {item.color && (
                    <div className="minicart-prd-qty d-flex align-items-center" style={{ gap: "5px" }}>
                        <span className="minicart-prd-qty-label">Color:</span>
                        {item.color_hex && (
                            <span 
                                className="color-swatch-circle" 
                                style={{ backgroundColor: item.color_hex, width: '15px', height: '15px', display: 'inline-block', borderRadius: '50%', border: '1px solid #ccc' }}
                            />
                        )}
                        <span className="minicart-prd-qty-value text-uppercase">{item.color}</span>
                    </div>
                )}
                <div className="minicart-prd-price prd-price mt-0">
                    <div className="price-new">
                        {item.price === "**" || String(item.price).trim() === "**" ? "**" : `$${roundToDecimal(parseFloat(item.price) * parseInt(item.quantity))}`}
                    </div>
                </div>
            </div>
            <div className="minicart-prd-action">
                <button
                    className="js-product-remove border-0 padding-0 bg-transparent"
                    type="button"
                    onClick={() => onRemove(index)}
                >
                    <i className="icon-recycle" />
                </button>
            </div>
        </div>
    );
};

export default MiniCartItem;
